export enum ChatNotificatioPayload {
  newMessage = 'newMessage',
  messagePayloadUpdate = 'messagePayloadUpdate',
  refreshedMessage = 'refreshedMessage',
  newConversation = 'newConversation',
  reassignConversation = 'reassignConversation',
  reopenConversation = 'reopenConversation',
  assigneeUpdate = 'assigneeUpdate',
  statusUpdate = 'statusUpdate',
  notifyChime = 'notifyChime',
  conversationParticipantsUpdate = 'conversationParticipantsUpdate',
  newNonqliqMessage = 'newNonqliqMessage',
  command = 'command',
}
